export default function initStepper(): void {
    const $stepperContainer = document.querySelectorAll<HTMLElement>('.js-stepper');
    $stepperContainer.forEach($container => {
        new Stepper($container);
    });
}

class Stepper {
    $el: HTMLElement | null | undefined;
    breakpoint: number;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.breakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm'));
        window.addEventListener('resize', this.mobileHandler.bind(this));
        this.tabHandler();
        this.tabOverflowHandler();
        this.mobileHandler();
    }

    tabHandler(): void {
        if (this.$el) {
            const $tabControls = this.$el.querySelectorAll('.js-tab-button');
            const $tabWrappers = this.$el.querySelectorAll('.js-tab-wrapper');

            $tabControls[0].classList.add('active');
            $tabWrappers[0].classList.add('active');

            $tabControls.forEach($control => {
                $control.addEventListener('click', (e: Event) => {
                    if ($control.classList.contains('active')) {
                        return;
                    } else {
                        $tabControls.forEach($control => $control.classList.remove('active'));
                        $control.classList.add('active');

                        const $selectedTab = this.$el?.querySelector('.js-selected-tab') as HTMLElement;

                        const $target = e.currentTarget as HTMLElement;
                        const $tabName = $target.textContent?.trim();

                        if ($selectedTab && $tabName) {
                            $selectedTab.textContent = $tabName;
                        }

                        $tabWrappers.forEach($tabWrapper => {
                            $tabWrapper.classList.remove('active');
                            if ($tabWrapper.getAttribute('data-tab') == $tabName) {
                                $tabWrapper.classList.add('active');
                            }
                        })
                    }
                })
            })
        }
    }


    tabOverflowHandler(): void {
        if (this.$el) {
            const $tabWrapper = this.$el.querySelector('.tabs-controls-wrapper') as HTMLElement;
            if ($tabWrapper) {
                const overflowChecker = () => {
                    const isOverflow = $tabWrapper.scrollWidth > $tabWrapper.clientWidth;
                    if (isOverflow) {
                        let isDown = false;
                        let startX: number;
                        let scrollLeft: number;
                        let hasMoved = false;

                        $tabWrapper.addEventListener('mousedown', (e) => {
                            isDown = true;
                            hasMoved = false;
                            $tabWrapper.classList.add('grabbing');

                            startX = e.pageX - $tabWrapper.offsetLeft;
                            scrollLeft = $tabWrapper.scrollLeft;
                        });

                        $tabWrapper.addEventListener('mouseleave', () => {
                            isDown = false;
                            $tabWrapper.classList.remove('grabbing');
                        });

                        $tabWrapper.addEventListener('mouseup', () => {
                            isDown = false;
                            $tabWrapper.classList.remove('grabbing');
                        });

                        $tabWrapper.addEventListener('mousemove', (e) => {
                            if (!isDown) return;
                            e.preventDefault();

                            hasMoved = true;

                            const x = e.pageX - $tabWrapper.offsetLeft;
                            const walkX = (x - startX) * 2;

                            $tabWrapper.scrollLeft = scrollLeft - walkX;
                        });

                        $tabWrapper.addEventListener('click', (e) => {
                            if (hasMoved) {
                                e.preventDefault();
                                e.stopPropagation();
                                return;
                            }

                            const target = e.target as HTMLElement;
                            const link = target.closest('.tab') as HTMLElement;

                            if (link) {
                                const elementLeft = link.offsetLeft;
                                const elementWidth = link.offsetWidth;
                                const containerWidth = $tabWrapper.offsetWidth;

                                const targetScroll = elementLeft - (containerWidth / 2) + (elementWidth / 2);

                                $tabWrapper.scrollTo({
                                    left: targetScroll,
                                    behavior: 'smooth'
                                });
                            }
                        });
                    }
                }

                window.addEventListener('resize', overflowChecker);
                window.addEventListener('load', overflowChecker);

                overflowChecker();
            }
        }
    }

    mobileHandler(): void {
        if (window.innerWidth < this.breakpoint) {
            this.$el?.classList.add('mobile');

        } else if (window.innerWidth > this.breakpoint) {
            this.$el?.classList.remove('mobile');
        }

        if (this.$el?.classList.contains('mobile')) {
            const select = document.querySelector('.tabs-controls');

            select?.addEventListener('click', (e) => {
                e.stopPropagation();
                select.classList.toggle('active');
            });

            document.addEventListener('click', (e) => {
                if (select && !select.contains(e.target as Node)) {
                    select.classList.remove('active');
                }
            });
        }

    }
}


